// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-validate-green{color:#24a285!important;font-size:1.5em!important;text-align:center!important;padding:25px 15px 5px 15px!important}.text-validate-black{color:#000!important;font-size:1rem!important;line-height:1.25rem;text-align:center!important;padding-bottom:5px!important}", ""]);
// Exports
module.exports = exports;
